<template>
  <div id="xxx_main" :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img">
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">微信认证</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none">
      </div>
    </div>

    <div class="bind-clock">
      <div class="wechat ub ub-ac ub-pc">
        <img src="../../assets/img/绑定微信logo.png">
      </div>

      <div class="bind-explain" v-if="!wx_check">
        <p>
          微信认证，可以提高您在系统中的信任度；
        </p>
        <p>
          经平台审核通过后，其他用户可通过支付金币的方式购买到您的微信号，同时，您将获取到相应的收益，可直接进行提现。
        </p>
        <p>
          为了防止骗子、广告混入其中，平台客服会添加您的微信号进行审核，烦请配合客服审核工作。
        </p>
      </div>

      <div class="bind-explain" v-if="wx_check == '待审核'">
        <p>
          审核中... 请耐心等待一哈（预计1~2个工作日）
        </p>
      </div>

      <div class="bind-explain" v-if="wx_check == '通过'">
          <p>
            恭喜你认证成功，系统已为你提高了安全等级；记得有人添加你微信号及时通过，好顺利拿到平台的佣金。
          </p>
        </div>

        <div class="bind-explain" v-if="wx_check == '未通过'">
            <p>
               您的微信号认证失败，请重新认证一下
            </p>
          </div>

      <div class="ub ub-pc wechat-name">
        <img src="../../assets/img/绑定微信.png" class="bind-img">
        <input type="text" v-model="wx" placeholder="请输入您的微信号">
      </div>
      <div class="bind-chat">请确保将要绑定的微信帐号为本人所有</div>

      <div class="chat-btn" @click="bindWx()">立即绑定</div>

    </div>

  </div>
</template>

<script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../../api/common";
  export default {
    data() {
      return {
        wx: '',
        wx_check: '',
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
        var uid = this.$store.state.uid;
        var self = this;

        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            var wx = u.wx;
            var wx_check = u.wx_check;
            self.wx = wx;
            self.wx_check = u.wx_check;
          }
        });
      },
      bindWx() {
        var wx = this.wx;
        var wx_check = this.wx_check;

        if(wx_check == "通过"){
          this.$toast.center('您已完成认证啦');
          return false;
        }

        if(wx_check == "待审核"){
          this.$toast.center('审核中，请耐心等待一哈~');
          return false;
        }

        if (wx == '') {
          this.$toast.center('微信号不能为空');
          return false;
        }

        if (wx.length < 5 || wx.indexOf('*') > -1) {
          this.$toast.center('微信号错误');
          return false;
        }

        //保存数据
        var send_data = { 'wx': wx, 'wx_check':'待审核' };
        this.save_serve(send_data);
      },

      save_serve(send_data) {
        //后台保存信息
        var self = this;
        var uid = this.$store.state.uid;
        //var send_data = {'nick' : nick};
        var data = {
          url: '/App/User_ModifyBaseInfo',
          data: {
            'uid': uid,
            'data': JSON.stringify(send_data)
          },
          success: function (data_serve) {
            if (data_serve.state == '1') {
              self.act_reload_userinfo({
                'uid': uid,
                success: function (info) {
                  self.$toast.center('微信号已提交，等待审核');
                  self.init_page();
                }
              })
            }
          }
        }
        self.post(data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .bind-clock {
    padding: .8rem;
    .wechat {
      height: 8rem;
      img {
        width: 8rem;
      }
    }
    .bind-explain {
      display: block;
      color: #333;
      font-size: .9rem;
      margin-bottom: 2rem;
    }
    .wechat-name {
      margin-top: .5rem;
      padding: 0.2rem 0.8rem;
      border: 1px solid #9dcef7;
      height: 2rem;
      font-size: .95rem;
      border-radius: 0.3rem;
      .bind-img {
        width: 1.5rem;
      }
      input {
        background-color: transparent;
        margin-left: 0.8rem;
        border: 0;
        outline: 0;
        font-size: 1rem;
        width: 100%;
      }
    }
    .bind-chat {
      text-align: center;
      color: #8a8a8a;
      font-size: .8rem;
      margin-top: .8rem;
      display: none;
    }
    .chat-btn {
      height: 2rem;
      color: #fff;
      line-height: 2rem;
      background-color: #e92162;
      text-align: center;
      font-size: 1.15rem;
      width: 100%;
      border-radius: 0.3rem;
      margin-top: 1rem;
    }
    
  }

  .container-dark {
    min-height: 100vh;
    background-color: #2f2e33;
    .bind-explain {
      color: #DFDFDF;
    }
    .wechat-name {
      border: 1px solid #404040;
    }
    input {
      color: #fdfdfd;
    }
  }
</style>